module.exports = __webpack_public_path__ + "static/img/share_img1.30bbbadc.png";